import { useContext } from 'react';
// import { AuthContext } from 'src/contexts/auth/jwt-context';
import { AuthContext } from 'src/contexts/auth/firebase-context';


export const useAuth = () => useContext(AuthContext);
